/**
 * StepIndicator — Animated dot progress for walkthrough steps.
 */
import { motion } from "framer-motion";

interface Props {
  totalSteps: number;
  currentStep: number;
}

export default function StepIndicator({ totalSteps, currentStep }: Props) {
  return (
    <div className="flex items-center gap-1.5">
      {Array.from({ length: totalSteps }).map((_, i) => (
        <motion.div
          key={i}
          initial={false}
          animate={{
            width: i === currentStep ? 24 : 8,
            backgroundColor: i === currentStep
              ? "hsl(var(--primary))"
              : i < currentStep
                ? "hsl(var(--primary) / 0.4)"
                : "hsl(var(--muted-foreground) / 0.25)",
          }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
          className="h-2 rounded-full"
        />
      ))}
    </div>
  );
}
